module.exports = __webpack_public_path__ + "img/LREXshapeHandingBox.475e9eac.png";